import { useTranslation } from "react-i18next";
import VestelIcon from "../../../atoms/images/VestelIcon";
import Text from "../../content/Text";

const DesktopBanner = () => {
  const { t } = useTranslation();
  return (
    <div className="logo-background flex items-center justify-start h-[120px]">
      <div>
        <VestelIcon className="w-[171px] h-[171px]" />
      </div>
      <div>
        <Text variant="h2" className="text-white">
          {t("layout.vestel-user-management")}
        </Text>
      </div>
    </div>
  );
};

export default DesktopBanner;
